import React, { useState, useEffect } from 'react';
import Web3 from 'web3';
import Web3Modal from 'web3modal';
import WalletConnectProvider from '@walletconnect/web3-provider';
import {
  helperAddress,
  unilendV2core,
  unilendV2position,
} from '../constants/contracts_sepolia.json';
import { networks } from '../constants/networks';
import {
  saveToLocalStorage,
  getFromLocalStorage,
  removeFromLocalStorage,
} from '../utils';
import { unilendV2coreABI, unilendV2helperABI } from '../constants/abis';

// import networks from "../assets/networks.json";

//Infura ID : b282ec895c084cdab3255b9a2399df2e

//For Balance
import ERC20ABI from '../assets/abi-erc20.json';

export const getErc20Contract = (tokenAddress, web3) => {
  return web3
    ? new web3.eth.Contract(ERC20ABI, tokenAddress, {
        from: web3.eth.defaultAccount,
      })
    : null;
};

const getEthereumContract = async (tokenAddress) => {
  let provider = await Web3Modal.connect();
  let web3 = new Web3(provider);

  const signer = provider.getSigner();
  const transactionContract = new web3.eth.Contract(
    tokenAddress,
    ERC20ABI,
    signer
  );

  return transactionContract;
};

export const WalletContext = React.createContext();

export const WalletProvider = ({ children }) => {
  const [currentAccount, setCurrentAccount] = useState('');
  const [currentNetworkId, setCurrentNetworkId] = useState();
  const [accountBalance, setAccountBalance] = useState('');
  const [isConnected, setIsConnected] = useState(false);
  const [uV2Core, setUv2Core] = useState();
  const [uV2Helper, setUv2Helper] = useState();
  const [uWeb3, setUWeb3] = useState();
  const [error, setError] = useState();

  const providerOptions = {
    binancechainwallet: {
      package: true,
    },
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        // infuraId: 'b282ec895c084cdab3255b9a2399df2e',
        infuraId: 'fd88775ae0d44888b49711c0acf5bc62',
      },
    },
  };

  const web3modal = new Web3Modal({
    network: '',
    theme: 'dark',
    cacheProvider: true,
    providerOptions,
  });

  const saveAccountStates = (
    account = '',
    networkId = '',
    bal = '',
    net = ''
  ) => {
    setCurrentAccount(account);
    setCurrentNetworkId(networkId.toString());
    setAccountBalance(bal);
    setIsConnected(account ? true : false);
    if (account !== '') {
      saveToLocalStorage('currentAccount', {
        account: account,
        balance: bal,
        chainId: networkId,
        network: net,
      });
    } else {
      removeFromLocalStorage('currentAccount');
    }
  };

  const connectWallet = async () => {
    let provider = await web3modal.connect();
    let web3 = new Web3(provider);
    await window.ethereum.send('eth_requestAccounts');
    const chainId = await web3.eth.getChainId();

    const net = (await web3.eth.net.getNetworkType()).toUpperCase();
    let accounts = await web3.eth.getAccounts();
    const uV2core_value = new web3.eth.Contract(
      unilendV2coreABI,
      unilendV2core
    );
    const uV2Helper_value = new web3.eth.Contract(
      unilendV2helperABI,
      helperAddress
    );

    if (accounts.length > 0) {
      const bal = await web3.eth.getBalance(accounts[0]);
      const balance = web3.utils.fromWei(bal, 'ether').slice(0, 6);
      saveAccountStates(accounts[0], chainId, balance, net);
    } else {
      setIsConnected(false);
    }
    setUv2Core(uV2core_value);
    setUv2Helper(uV2Helper_value);
    setUWeb3(web3);
  };

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', function (accounts) {
        connectWallet();
      });

      window.ethereum.on('chainChanged', async (chain) => {
        connectWallet();
      });
    }
  }, []);

  useEffect(() => {
    const currentAccount = getFromLocalStorage('currentAccount');
    if (currentAccount) {
      saveAccountStates(
        currentAccount.account,
        currentAccount.chainId,
        currentAccount.balance
      );
    }
  }, [getFromLocalStorage('currentAccount')]);

  const disconnect = async () => {
    saveAccountStates();
  };

  const switchNetwork = (networkId) => {
    changeNetwork(networkId);
  };

  const changeNetwork = async (networkId) => {
    try {
      if (!window.ethereum) throw new Error('No crypto wallet found');
      const account = await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [
          {
            chainId: `0x${Number(Number(networkId)).toString(16)}`,
          },
        ],
      });
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                ...networks[networkId],
              },
            ],
          });
        } catch (err) {
          setError(err.message);
        }
      }
    }
  };

  // const changeNetwork = async ( networkId ) => {
  //   try {
  //     alert("switch")
  //     if (!window.ethereum) throw new Error("No crypto wallet found");
  //     await window.ethereum.request({
  //       method: "wallet_addEthereumChain",
  //       params: [
  //         {
  //           ...networks[networkId],
  //         },
  //       ],
  //     });

  //     const chainId = await uWeb3.eth.getChainId();
  //     alert(chainId);

  //   } catch (err) {
  //     setError(err.message);
  //   }
  // };

  return (
    <WalletContext.Provider
      value={{
        currentAccount,
        currentNetworkId,
        accountBalance,
        isConnected,
        getErc20Contract,
        uV2Core,
        uV2Helper,
        uWeb3,
        connectWallet,
        disconnect,
        switchNetwork,
      }}
    >
      {children}
    </WalletContext.Provider>
  );
};
